import AdminOverrides from "./Admin/AdminOverrides";
import AgentOverrides from "./Agent/AgentOverrides";
import { isFieldAgent } from "../../utils/roleDetection";

const Overrides = () => {
	const stored = localStorage.getItem("loggedin_data");
	const user = stored ? JSON.parse(stored) : null;
	const roles = Array.isArray(user?.roles) ? user.roles : [];
	const isAgent = isFieldAgent(roles);

	return isAgent ? <AgentOverrides /> : <AdminOverrides />;
};

export default Overrides;
